/**
 * @param {any[]} items
 * @return {any}
 */
export default function rand(items) {
  return items[Math.floor(Math.random() * items.length)];
}
